import { SidebarItems } from './SidebarContainer'
import React from 'react'
import SidebarContainer from './SidebarContainer'
import '../../css/Sidebar.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAddressCard,
  faCartShopping,
  faChartPie,
  faChartSimple,
  faCreditCard,
  faEye,
  faFileContract,
  faFileInvoice,
  faGift,
  faListCheck,
  faLock,
  faPowerOff,
  faReceipt,
  faSitemap,
  faStore,
  faUserGear,
  faUsers,
  faUsersViewfinder,
  faWarehouse
} from '@fortawesome/free-solid-svg-icons'
import { useSelector } from 'react-redux'

const Sidebar = () => {
  const userDetails = useSelector(store => store.user)
  return (
    <SidebarContainer>
      <SidebarItems
        icon={<FontAwesomeIcon icon={faChartPie} />}
        text='Dashboard'
        link='/dashboard'
      />

      <SidebarItems
        icon={<FontAwesomeIcon icon={faChartSimple} />}
        text='CRM Reports'
        link='reports'
      />


      {
        userDetails.role !== 'store_manager' ? (
          <SidebarItems
            icon={<FontAwesomeIcon icon={faUserGear} />}
            text='CRM Resources'
            link='org_contact'
          />
        ) : (
          ''
        )
      }

      {
        userDetails.role === 'super_admin' || userDetails.role === 'admin' ? (
          <>
            <SidebarItems
              icon={<FontAwesomeIcon icon={faSitemap} />}
              text='Business Line'
              link='business_line'
            />
          </>
        ) : (
          ''
        )
      }

      {
        userDetails.role === 'store_manager' ||
          userDetails.role === 'admin' ||
          userDetails.role === 'super_admin' || userDetails.role === 'commercial_manager' || userDetails.role === 'commercial_executive' ? (
          <SidebarItems
            icon={<FontAwesomeIcon icon={faWarehouse} />}
            text='Inventory'
            link='/store_home'
          />
        ) : (
          ''
        )
      }

      <SidebarItems
        icon={<FontAwesomeIcon icon={faReceipt} />}
        text='Invoice Journey'
        link='/invoice_journey_start'
      />

      {
        userDetails.role !== 'store_manager' &&
          userDetails.role !== 'commercial_manager' &&
          userDetails.role !== 'commercial_executive' ? (
          <>
            <SidebarItems
              icon={<FontAwesomeIcon icon={faUsers} />}
              text='Add Client'
              link='/add_client_contact'
            />
          </>
        ) : (
          ''
        )
      }

      <SidebarItems
        icon={<FontAwesomeIcon icon={faUsersViewfinder} />}
        text='Client Contact'
        link='/client_contact'
      />

      {
        userDetails.role === 'manager' || userDetails.role === 'executive' ? (
          <SidebarItems
            icon={<FontAwesomeIcon icon={faAddressCard} />}
            text='New Lead'
            link='/lead'
          />
        ) : (
          ''
        )
      }
      {
        userDetails.role !== 'store_manager' ? (
          <SidebarItems
            icon={<FontAwesomeIcon icon={faEye} />}
            text='View Lead'
            link='/view_leads'
          />
        ) : (
          ''
        )
      }

      <SidebarItems
        icon={<FontAwesomeIcon icon={faGift} />}
        text='FOC'
        link='/foc'
      />

      {
        userDetails.role === 'commercial_executive' ||
          userDetails.role === 'commercial_manager' ||
          userDetails.role === 'store_manager' ? (
          <>
            <SidebarItems
              icon={<FontAwesomeIcon icon={faReceipt} />}
              text='FOC Invoice Journey'
              link='/foc_invoice_journey_start'
            />

          </>
        ) : (
          ''
        )
      }

      {
        userDetails.role === 'manager' ||
          userDetails.role === 'commercial_manager' ? (
          <SidebarItems
            icon={<FontAwesomeIcon icon={faFileInvoice} />}
            text='View SO'
            link='/view_so'
          />
        ) : (
          ''
        )
      }

      {
        userDetails.role === 'admin' || userDetails.role === 'store_manager' |
          userDetails.role === 'super_admin' || userDetails.role === 'commercial_executive' || userDetails.role === 'commercial_manager' ? (
          <SidebarItems
            icon={<FontAwesomeIcon icon={faStore} />}
            text='Add Vendor'
            link='/purchase/add_vendor'
          />
        ) : (
          ''
        )
      }
      {
        userDetails.role === 'admin' || userDetails.role === 'store_manager' ||
          userDetails.role === 'super_admin' || userDetails.role === 'commercial_executive' || userDetails.role === 'commercial_manager' ? (
          <SidebarItems
            icon={<FontAwesomeIcon icon={faEye} />}
            text='View Vendor'
            link='/purchase/view_vendors'
          />
        ) : (
          ''
        )
      }



      {
        userDetails?.role === 'commercial_executive' || userDetails?.role === 'project_incharge' || userDetails?.role === 'store_manager' ? (
          <SidebarItems
            icon={<FontAwesomeIcon icon={faCartShopping} />}
            text='Purchase Request'
            link='/purchase_request'
          />
        ) : (
          ''
        )
      }

      {
        userDetails?.role === 'commercial_executive' || userDetails?.role === 'project_incharge' || userDetails?.role === 'commercial_manager' || userDetails?.role === 'store_manager' ? (
          <SidebarItems
            icon={<FontAwesomeIcon icon={faListCheck} />}
            text='View PR'
            link='/view_pr'
          />
        ) : (
          ''
        )
      }

      {
        userDetails.role === 'commercial_manager' ? (
          <>
            <SidebarItems
              icon={<FontAwesomeIcon icon={faGift} />}
              text='Foc So'
              link='/view_foc_so'
            />
            <SidebarItems
              icon={<FontAwesomeIcon icon={faFileContract} />}
              text='New Quotation'
              link='/purchase/create_quotation'
            />
            <SidebarItems
              icon={<FontAwesomeIcon icon={faEye} />}
              text='View Quotation'
              link='/purchase/view_quotations'
            />
          </>
        ) : (
          ''
        )
      }

      {
        userDetails.role === 'commercial_manager' || userDetails.role === 'store_manager' ? (
          <>
            <SidebarItems
              icon={<FontAwesomeIcon icon={faEye} />}
              text='View PO'
              link='/purchase/view_po'
            />
            <SidebarItems
              icon={<FontAwesomeIcon icon={faEye} />}
              text='View WO'
              link='/purchase/view_wo'
            />
            <SidebarItems
              icon={<FontAwesomeIcon icon={faCreditCard} />}
              text='Debit Notes'
              link='/purchase/view_debit_notes'
            />
          </>
        ) : (
          ''
        )
      }



      <SidebarItems
        icon={<FontAwesomeIcon icon={faLock} />}
        text='Update Password'
        link='/update_password'
      />
      <SidebarItems
        icon={<FontAwesomeIcon icon={faPowerOff} />}
        text='Sign Out'
      />
    </SidebarContainer >
  )
}

export default Sidebar
